var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":_vm.name}}):_c('gravatar',{attrs:{"default-img":_vm.defaultImg,"email":_vm.email,"alt":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }